<template>
    <!-- 场地管理－修修改场次时间 -->
    <content-view>
        <div class="amendScreening">
            <a-alert
                description="选择关闭场次库存相当于直接冻结对应场次，用户将不可在小程序进行对应场次的预约操作"
                type="warning"
                showIcon
            />
            <div id="components-layout-demo-basic" class="mt16">
                <a-layout>
                    <a-layout-sider style="border: 1px solid rgba(233, 233, 233, 1)">
                        <inventory-list></inventory-list>
                    </a-layout-sider>
                    <a-layout style="background:#fff">
                        <a-form :form="form">
                            <table style="line-height:34px;" class="mb16 mt16">
                                <tr>
                                    <td width="100" class="text-right pr8">
                                        日期范围:
                                    </td>
                                    <td>
                                        <a-form-item style="margin:0;">
                                            <a-range-picker v-decorator="['dateRange', {rules:[{required: true, message: '请输入'}]}]" style="width:100%;"/>
                                        </a-form-item>
                                    </td>
                                    <td width="80" class="text-right pr8">
                                        时间范围:
                                    </td>
                                    <td>
                                        <a-form-item style="margin:0;">
                                            <a-time-picker v-decorator="['time0']" format="HH:mm" style="width:110px"/>
                                            至
                                            <a-time-picker v-decorator="['time1']" format="HH:mm" style="width:110px"/>
                                        </a-form-item>
                                    </td>
                                </tr>
                            </table>
                            <table style="line-height:34px;" class="mb16">
                                <tr>
                                    <td width="80" class="text-right pr8">
                                        选择星期:
                                    </td>
                                    <td>
                                        <a-form-item style="margin:0;">
                                            <a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange">全选</a-checkbox>
                                            <a-checkbox-group :options="weekOption" @change="onWeekChange" v-model="weedSelected"></a-checkbox-group>
                                        </a-form-item>
                                    </td>
                                    <td>
                                        <a-button class="ml16" type="primary" @click="onSubmit">筛选</a-button>
                                        <a-button @click="resetForm">重置</a-button>
                                    </td>
                                </tr>
                            </table>
                            <a-table
                                class="ml16 mr16 mb16"
                                :columns="columns"
                                :dataSource="data"
                                :rowKey="(record,index) => record.id"
                                :pagination="false"
                                :scroll="{y: 280}"
                                :loading="tableShowLoading"
                                :rowSelection="{onChange: onSelectChange }"
                                bordered
                            >
                                <span slot="reserveNum" slot-scope="reserveNum, row">{{(row.capacity - reserveNum)}}</span>
                                <span slot="state" slot-scope="a,row">
                                    <a class="text-primary" @click="exportExcel(row.id)">导出已预约名单</a>
                                </span>
                            </a-table>
                            <div class="mt16 mb16">
                                <a-button @click="closePeriodList" type="primary">确认关闭选中场次</a-button>
                                <a-button @click="exportBatch">批量导出</a-button>
                                <a-button @click="$router.go(-1)">取消并返回</a-button>
                            </div>
						</a-form>
                    </a-layout>
                </a-layout>
            </div>
        </div>
		<!-- 修改场次库存弹窗 -->
        <a-modal
            title="确认关闭选中场次"
            :visible="visible"
            @ok="handleOk"
            :confirmLoading="confirmLoading"
            @cancel="visible = false"
        >
            <a-form :form="periodForm" class="store-one-form">
				<a-form-item label="短信通知已预约用户" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
					<a-radio-group
					name="sendState"
					@change="onChangeInfo"
					v-decorator="['sendState',{initialValue: 0}]"
					>
						<a-radio :value="0">否</a-radio>
						<a-radio :value="1">是</a-radio>
					</a-radio-group>
				</a-form-item>
				<a-form-item label="短信内容" :labelCol="{span: 7}" :wrapperCol="{span: 17}">
					<a-textarea 
					placeholder="最多输入150个字符" 
					:maxLength="150" 
					:autosize="{ minRows: 3, maxRows: 8 }"
                    :disabled="!showContent"
					@change="onChangeText" 
					v-decorator="['content',{rules: [{required: showContent, message: '请输入发送的短信内容'}]}]"
					></a-textarea>
					<span>{{lengthTips}}/150</span>
				</a-form-item>
            </a-form>
        </a-modal>
    </content-view>
</template>

<script type="text/javascript">
import inventoryList from "@/components/modules/platform/Inventory.list.component";
import moment from "moment";
import { mapGetters } from "vuex";
/**
 *@weekOption 复选框组配置
 */
const weekOption=[
	{label:"周一",value:1},
	{label:"周二",value:2},
	{label:"周三",value:3},
	{label:"周四",value:4},
	{label:"周五",value:5},
	{label:"周六",value:6},
	{label:"周日",value:7},
	]
const columns = [
    {
        title: "场次名称",
		dataIndex: "reserveStockPeriodType",
		width:"15%"
    },
    {
        title: "场次日期",
		dataIndex: "reserveDate",
		width:"15%"
    },
    {
        title: "场次开始时间",
		dataIndex: "startTime",
		width:"17%"
    },
    {
        title: "场次结束时间",
		dataIndex: "endTime",
		width:"17%"
    },
    {
        title: "每日库存总量",
		dataIndex: "capacity",
		width:"10%"
    },
    {
        title: "当前库存总量",
		dataIndex: "reserveNum",
		scopedSlots: { customRender: 'reserveNum' },
		width:"10%"
    },
    {
        title: "操作",
		dataIndex: "state",
		scopedSlots: { customRender: 'state' },
		width:"21%"
    }
];
export default {
    name: "amendScreening",
    components: { inventoryList },
    props: {},
    data() {
		/** 
		*@weekOption {array} 星期选择配置
		*@weedSelected {array} 星期选中项
		*@indeterminate {boolean} 半全选状态
		*@checkAll {boolean} 全选状态
		*@columns {array} 默认表头
		*@tableShowLoading {boolean} 表格加载状态
		*@data	{array} 默认表格数据
		*@visible {boolean} 修改库存弹窗状态
		*@confirmLoading {boolean} 修改库存弹窗保存按钮加载状态
		*@usefulPeriodData {array} 可用日期弹窗表格数据
		*/
        return {
			weekOption,
			weedSelected:[],
			indeterminate:false,
			checkAll:false,
			columns,
			tableShowLoading:false,
            data:[],
            visible: false,
			confirmLoading: false,
			loading : false,
			usefulPeriodData:[],
			selectedRowId: '',
            selectedRowId:null,
            selectedRows: [],
            showContent: false,
            lengthTips: 0
        };
    },
    computed: {
        ...mapGetters(["currentItem", "currnetId", "shopId"])
	},
	watch:{
		currnetId () {
			this.getPeriodList({id: this.currnetId});
		}
	},
    methods: {
        /**
         * @startDateChange 开始日期变动联动结束日期
         */
        startDateChange(date) {
            if(!date) return false
            this.form.setFieldsValue({'endDate': this.$moment(date).add(1,'months')});
        },
		disabledEndDate(endValue) {
            let startValue = this.form.getFieldValue('startDate');
            if (!startValue || !endValue) {
                return false;
            }
			return startValue.valueOf() > endValue.valueOf() || this.$moment(startValue).add(1,'months') <= this.$moment(endValue);
		},
        onSelectChange(selectedRowKeys, selectedRows) {
            this.selectedRows = [];
            this.selectedRows = selectedRows.map(el => el.id)
        },
		/**
		 * @onSubmit {method} 筛选提交事件
		 */
		onSubmit (){
			this.getPeriodList();
		},
		/**
		 *@resetForm 表单重置
		 */
		resetForm () {
			this.form.resetFields();
			this.weedSelected=[];
			this.checkAll=false;
			this.indeterminate=false;
        },
		/**
		 *@onWeekChange {method} 是否全选状态判断
		 */
		onWeekChange (checkedList) {
			this.indeterminate = !!checkedList.length && (checkedList.length < weekOption.length)
			this.checkAll = checkedList.length === weekOption.length
		},
		/**
		 *@onCheckAllChange {method} 是否全选操作
		 */
		onCheckAllChange (e) {
			let weedVal=[];
			weekOption.forEach((item,index) =>{
				weedVal.push(item.value);
			})
			Object.assign(this, {
				weedSelected: e.target.checked ? weedVal : [],
				indeterminate: false,
				checkAll: e.target.checked,
			})
		},
		/**
		 * @getPeriodList {method} 库存配置场次列表
		 * @reqData {object} 请求数据{endDate，endTime，id(库存项目id)，startDate，startTime，weekdayList}
		 */
		getPeriodList () {
			this.form.validateFields((err,values) => {
				if(!err){
                    if (!values.dateRange || !values.dateRange.length) {
						this.data = [];
						this.$message.warning("请选择日期")
						return 
					}
					var reqData = {
						"endDate": values.dateRange[1] ? moment(values.dateRange[1]).format("YYYY-MM-DD") : undefined,
						"endTime": values.time1 ? (moment(values.time1._d).format("HH:mm:00")) : undefined,
						"reserveStockId": this.currnetId,
						"startDate": values.dateRange[0] ? moment(values.dateRange[0]).format("YYYY-MM-DD") : undefined,
						"startTime": values.time0 ? (moment(values.time0._d).format("HH:mm:00")) : undefined,
						"weeks": this.weedSelected.length ? this.weedSelected : []
					};
					this.tableShowLoading=true;
					this.$api.totalPlatform.getClosePeriodList({
						body:reqData
					}).then((data) => {
                        this.tableShowLoading = false;
                        if (!data) return;
                        data.forEach(el => {
                            el.id = el.id * 1;
                        })
                        this.data = data || [];
					}).catch(err => {
                        this.tableShowLoading=false;
                    })
				}
			})
		},
        // 导出excel
        exportExcel(id) {
            this.loading = true;
            this.$api.totalPlatform.batchExport({
				body: {
                    reserveStockPeriodId: id
                }
			})
			.then(res => {
				let a = document.createElement("a");
				a.setAttribute("href", res);
				a.click();
			});
        },
        exportBatch() {
            if(this.selectedRows.length == 0 ) {
                this.$message.error('请勾选需要导出的场次已预约者名单')
                return false
            }
            this.$api.totalPlatform.batchExport({
                body: {
                    reserveStockPeriodIdList: this.selectedRows
                }
            }).then(res => {
                let a = document.createElement("a");
                a.setAttribute("href", res);
                a.click();
            });
        },
        closePeriodList() {
            if(this.selectedRows.length == 0 ) {
                this.$message.error('请勾选需要批量关闭的场次')
                return false
            }
            this.visible = true
        },
        onChangeInfo(e){
            this.showContent = e.target.value === 1;
            this.periodForm.setFieldsValue({'content': ''});
            this.lengthTips = 0;
        },
        //文本域内容变化
        onChangeText(e){
            this.lengthTips = e.target.value.length
        },
        handleOk() {
			this.periodForm.validateFields((err,values) => {
				if(!err){
                    this.confirmLoading = true;
                    this.$api.totalPlatform.closePeriodList({
                        body: {
                            message: values.content,
                            reservePeriodIds: this.selectedRows,
                            isSendMessage: values.sendState,
                            state: 0,
                        }
                    })
                    .then(res => {
                        this.confirmLoading = false;
                        this.$message.success('操作成功');
                        this.$router.go(-1);
                    })
                    .catch(err => {
                        this.confirmLoading = false;
                    })
                }
            })
        }
        
	},
	beforeCreate(){
		this.form=this.$form.createForm(this);
		this.periodForm=this.$form.createForm(this);
	},
	created() {},
    mounted() {
        // this.getPeriodList()
	}
};
</script>
<style lang="scss">
.amendScreening {
    background-color: #fff;
    padding: 24px;
}
#components-layout-demo-basic {
    text-align: center;
    background: #fff;
}
#components-layout-demo-basic .ant-layout-header,
#components-layout-demo-basic .ant-layout-footer {
    background: #7dbcea;
    color: #fff;
}
#components-layout-demo-basic .ant-layout-footer {
    line-height: 1.5;
}
#components-layout-demo-basic .ant-layout-sider {
    background: #fff;
    color: #000000;
    font-size: 16px;
    .title {
        line-height: 60px;
        border-right: 1px solid rgba(233, 233, 233, 1);
        a {
            color: $text-color-primary;
        }
    }
}
</style>